import React, { useCallback, memo } from 'react';
import { useNavigate } from 'react-router';

import Icon from '../../../icons/Icon';

import scss from './ProjectCreateDashboard.module.scss';
import { ICONS } from '../../../icons';

const ProjectCard = ({ title, description, logo, path, disabled }) => {
  const navigate = useNavigate();

  const handleCreateProject = useCallback(() => {
    navigate(path);
  }, [navigate, path]);

  return (
    <div className={scss.cardWrapper}>
      <div className={scss.headerInfo}>
        <Icon icon={logo} className={scss.projectLogo} />
        <span className={scss.projectTitle}>{title}</span>
      </div>
      <span className={scss.projectDescription}>{description}</span>

      <button className={scss.createButton} onClick={handleCreateProject} disabled={disabled}>
        <Icon icon={ICONS.CirclePlus} />
      </button>
    </div>
  );
};

export default memo(ProjectCard);
